import LocalityPage from "../components/LocalityPage";
import { VILLES, VILLE_QUARTIERS, VILLE_NEARBY } from "../data/zones";

export default function Ville({ ville }) {
    const quartiers = VILLE_QUARTIERS[ville.slug] || [`Tous les quartiers de ${ville.name}`];
    const nearby = VILLE_NEARBY[ville.slug] || [];

    const q0 = quartiers[0] || ville.name;
    const q1 = quartiers[1] || ville.name;
    const q2 = quartiers[2] || ville.name;
    const nearbyStr = nearby.slice(0, 4).join(", ");
    const nearbyFull = nearby.slice(0, 6).join(", ");

    return (
        <LocalityPage
            name={ville.name}
            cp={ville.cp}
            kicker={`${ville.deptName} — ${ville.cp}`}
            crumb={ville.name}
            introTitle={`Serrurier de confiance à ${ville.name} (${ville.cp})`}
            introP1={`Porte claquée côté ${q0}, serrure abîmée près de ${q1} ou blindage à renforcer dans le quartier ${q2} ? Nos artisans serruriers couvrent toute la ville de ${ville.name} (${ville.cp}, département ${ville.dept}) : ouverture de porte sans casse dès 60 € TTC, changement de cylindre, blindage de porte certifié A2P, double de clé — avec devis gratuit communiqué avant chaque intervention. Agréés assurance habitation, dans le métier depuis 1985.`}
            introP2={`Nos équipes interviennent dans tous les quartiers de ${ville.name} — ${quartiers.slice(0, 4).join(", ")}… — et couvrent aussi les communes voisines : ${nearbyFull}. Service disponible 24h/24, 7j/7, nuits, week-ends et jours fériés compris — délai d'intervention garanti en 30 minutes dans tout le département ${ville.dept} (${ville.deptName}).`}
            chips={[...quartiers, `Département ${ville.dept} — ${ville.deptName}`]}
            others={VILLES.filter((v) => v.slug !== ville.slug)
                .slice(0, 14)
                .map((v) => ({ label: `Serrurier ${v.name}`, to: `/serrurier-${v.slug}` }))}
            path={`/serrurier-${ville.slug}`}
            seoTitle={`Serrurier ${ville.name} (${ville.cp}) — Urgence 24/7 · Intervention 30 min · Devis Gratuit`}
            seoDesc={`Serrurier ${ville.name} (${quartiers.slice(0, 3).join(", ")}) : ouverture de porte 60 € TTC, changement de serrure, blindage. Artisan agréé assurance, chez vous en 30 min à ${ville.name} (${ville.dept}), 24h/24. ☎ 06 25 25 86 19`}
        />
    );
}
